// @ts-nocheck
(function () {
  const details = document.querySelector('.product-details.sticky-content--desktop');
  if (!details) return;

  if (!window.matchMedia('(min-width: 900px)').matches) return;

  const offsetHeader = () => {
    const header = document.querySelector('header, .shopify-section-header, #shopify-section-header');
    if (header) {
      return header.getBoundingClientRect().height || 0;
    }

    return 0;
  };

  const gap = 32;

  const updateSticky = () => {
    // Available viewport height to sticky within
    const available = window.innerHeight - offsetHeader();
    const rect = details.getBoundingClientRect();
    const height = rect.height;

    if (height <= available) {
      // Fits in viewport → behave like normal sticky-top with 2rem padding
      details.style.position = 'sticky';
      details.style.top = '2rem';
      details.style.bottom = '';
      return;
    }

    // taller than viewport → calculate threshold
    const threshold = window.innerHeight - height - gap;

    details.style.position = 'sticky';
    details.style.top = `${threshold}px`;
    details.style.bottom = '';
  };

  window.addEventListener('resize', updateSticky);
  updateSticky();
})();
